<script setup>
import { ref, computed, watch } from "vue";
import { useGroupStore } from "@/stores/useGroupStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  group: { type: Object, required: true },
});

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useGroupStore();

// Congela o nome para a mensagem não mudar após clique/deleção/refresh
const frozenGroupName = ref("");

function freezeGroupName() {
  frozenGroupName.value = props.group?.groupName?.trim?.() || "";
}

watch(
  () => props.group?.groupName,
  () => freezeGroupName(),
  { immediate: true }
);

const modalTitle = "Apagar Grupo";

const messageTitle = computed(() => {
  const name = frozenGroupName.value;
  return name
    ? `Você está prestes a apagar o grupo "${name}".`
    : "Você está prestes a apagar este grupo.";
});

const messageSubtitle = computed(() => "Esta ação não pode ser desfeita.");

function buildErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir o grupo."
  );
}

async function onConfirmDelete() {
  freezeGroupName();

  try {
    await store.deleteGroupById(props.group.groupId);

    emit("notify", {
      type: "success",
      message: "Grupo apagado com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildErrorMessage(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    :title="modalTitle"
    :messageTitle="messageTitle"
    :messageSubtitle="messageSubtitle"
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
